import React from 'react';
import { useNavigate } from 'react-router-dom';

const TemplateCard = ({ template, onPreview, onDelete, onDuplicate }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <h3 className="font-semibold text-lg mb-2">{template.name}</h3>
      <p className="text-gray-600 text-sm mb-3">{template.description}</p>
      <div className="flex gap-2 flex-wrap">
        <button
          className="bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
          onClick={() => navigate(`/scenario-builder/${template.id}`)}
        >
          Edit
        </button>
        <button
          className="bg-green-500 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
          onClick={() => onPreview(template)}
        >
          Preview
        </button>
        <button
          className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-700"
          onClick={() => onDuplicate(template)}
        >
          Duplicate
        </button>
        <button
          className="bg-red-500 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
          onClick={() => onDelete(template.id, template.name)}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default TemplateCard;
